import { useQuery } from '@tanstack/react-query';

import { getDemoStatus } from '~apis/demo/getDemoStatus';

import { useCompanyId } from './useCompanyId';

export const DemoQueryKey = {
  status: () => ['demo', 'status'],
};

// 🎯 핵심: 서버 API 기반 useDemoCompanyId Hook
export const useDemoCompanyId = (): string | null => {
  const { companyId } = useCompanyId();

  const { data } = useQuery({
    queryKey: DemoQueryKey.status(),
    queryFn: () => getDemoStatus(companyId),
    enabled: !!companyId,
    staleTime: 1000 * 60, // 1분 캐싱
  });

  const demoStatus = data?.Data?.data;

  // 서버에서 useDemoData가 true이고 demoCompanyId가 있을 때만 반환
  return demoStatus?.useDemoData && demoStatus?.demoCompanyId ? demoStatus.demoCompanyId : null;
};
